import React, { useState, useEffect } from 'react';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const testimonials = [
    {
      content: "We were lucky to find a vendor like Venturecorp. We were looking for a 360 degree service provider for our organization. Since we work with Government backed customers, compliance and data security was a key requirement. Venturecorp was able to meet all the data security requirements for us.",
      name: "Cathy",
      position: "Canberra, Australia",
      initials: "C"
    },
    {
      content: "We moved from a popular vendor that made us very disappointed, to Venturecorp, and that decision was one of the best decisions we made during this year. Our USA team now has the peace of mind while Venturecorp takes care of things with their supreme service.",
      name: "PL",
      position: "California, USA",
      initials: "PL"
    },
    {
      content: "If there is a vendor that is truly forward thinking, best with the timely follow ups and above & beyond care, that is Venturecorp. We appreciate the partnership.",
      name: "Leo",
      position: "London, UK",
      initials: "L"
    },
    {
      content: "This is the first time we obtained some outsourced services from a Vendor, and we were hesitant how it might go. Venturecorp made us believe in outsourced services.",
      name: "Moe",
      position: "Dubai, UAE",
      initials: "M"
    }
  ];

  // Auto-cycle through testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      
      setTimeout(() => {
        setCurrentIndex((prevIndex) => 
          prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
        );
        setIsVisible(true);
      }, 300);
    }, 4000); // Change every 4 seconds

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const goToSlide = (index) => {
    setIsVisible(false);
    setTimeout(() => {
      setCurrentIndex(index);
      setIsVisible(true);
    }, 300);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="py-20 relative font-AfacadFluxLight overflow-hidden bg-slate-900">
      {/* Separator line at top */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-4/5 h-0.5 bg-white/50"></div>
      
      {/* Background gradient effects - matching About Us section */}
      <div className="absolute -top-20 -right-20 w-[600px] h-[600px]">
        <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-gradient-to-br from-purple-500/15 via-indigo-500/10 to-blue-500/5 rounded-full blur-3xl"></div>
        <div className="absolute top-20 right-20 w-[300px] h-[300px] bg-gradient-to-tl from-indigo-400/10 via-purple-400/8 to-violet-400/5 rounded-full blur-2xl"></div>
      </div>
      
      <div className="absolute -bottom-20 -left-20 w-[700px] h-[700px]">
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-gradient-to-br from-indigo-500/20 via-purple-500/12 to-violet-500/8 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-[400px] h-[400px] bg-gradient-to-tl from-purple-400/15 via-indigo-400/10 to-blue-400/6 rounded-full blur-2xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="mb-4">
            <span className="text-sm font-semibold tracking-widest uppercase text-purple-300">TESTIMONIALS</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-white leading-tight">
            What our clients say
          </h2>
          <p className="text-lg text-gray-300 mt-4 font-light max-w-2xl mx-auto">
            Discover how VentureCorp has transformed startups across the globe with our comprehensive support services
          </p>
        </div>

        {/* Main testimonial content */}
        <div className="text-center">
          <div className={`transition-all duration-300 transform ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}>
            {/* Quote icon */}
            <div className="mb-6">
              <svg className="w-10 h-10 text-purple-400 mx-auto" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
              </svg>
            </div>

            {/* Testimonial content with fixed height */}
            <div className="h-40 flex items-center justify-center mb-6">
              <blockquote className="text-lg md:text-xl text-white font-light leading-relaxed italic max-w-3xl mx-auto">
                "{currentTestimonial.content}"
              </blockquote>
            </div>

            {/* Profile initials
            <div className="mb-6">
              <div className="w-20 h-20 rounded-full mx-auto bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center border-2 border-gray-600">
                <span className="text-white font-bold text-xl">{currentTestimonial.initials}</span>
              </div>
            </div> */}

            {/* Author info */}
            <div className="text-center">
              <h4 className="text-lg font-semibold text-white mb-1">{currentTestimonial.name}</h4>
              <p className="text-gray-400 text-base">{currentTestimonial.position}</p>
            </div>
          </div>
        </div>

        {/* Navigation dots */}
        <div className="flex justify-center items-center mt-8 space-x-3">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentIndex 
                  ? 'bg-gradient-to-r from-purple-400 to-indigo-400 scale-125' 
                  : 'bg-gray-600 hover:bg-gray-500'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 